module.exports = __webpack_public_path__ + "06_medium_black.8a2c1e66.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/06_medium_black.png
// module id = ciB5
// module chunks = 0